<template>
  <b-badge
    class="module-self-diagnosis-status-badge"
    pill
    :variant="variant"
    v-text="label"
  />
</template>

<script>
import { moduleSelfDiagnosisStatus } from '@/domain/enums/moduleSelfDiagnosisStatus';

export default {
  props: {
    value: String,
  },
  computed: {
    variant() {
      switch (this.value) {
        case moduleSelfDiagnosisStatus.WITHOUT_SELF_DIAGNOSES_ACTIVATED:
          return 'active';
        case moduleSelfDiagnosisStatus.WITH_SELF_DIAGNOSES_ACTIVATED:
          return 'inactive';
        default:
          return 'indeterminate';
      }
    },
    label() {
      return this.$t(`enums.module-self-diagnosis-status.${this.value}`);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
@import "src/styles/vendor/customizations/custom-bootstrap-vars.sass"
@import ~bootstrap/scss/mixins/_badge
@import ~bootstrap/scss/mixins/_hover
@import "src/styles/components/badge-default-colors.sass"

.module-self-diagnosis-status-badge
  padding: 5px
  &.badge-active
    @include badge-variant($status-active)
    color: #fff
  &.badge-inactive
    @include badge-variant($status-inactive)
    color: #fff
  &.badge-indeterminate
    @include badge-variant($color-extend-pink)
    color: #fff
</style>
